import cerberCreator from './creator';

export default cerberCreator;
